import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import { useAuth } from '@/contexts/AuthContext';

export const useDashboardStats = () => {
  const { user } = useAuth();

  const { data } = useQuery({
    queryKey: ['dashboard-stats', user?.id],
    queryFn: async () => {
      if (!user?.id) return { draftReviews: 0, pendingRequests: 0 };

      const [reviewsResult, requestsResult] = await Promise.all([
        supabase
          .from('reviews')
          .select('id', { count: 'exact', head: true })
          .eq('reviewer_id', user.id)
          .eq('status', 'draft'),
        supabase
          .from('review_requests')
          .select('id', { count: 'exact', head: true })
          .eq('reviewer_id', user.id)
          .eq('status', 'pending')
      ]);

      return {
        draftReviews: reviewsResult.count || 0,
        pendingRequests: requestsResult.count || 0,
      };
    },
    enabled: !!user?.id,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: true,
  });

  return {
    draftReviews: data?.draftReviews || 0,
    pendingRequests: data?.pendingRequests || 0,
    totalPending: (data?.draftReviews || 0) + (data?.pendingRequests || 0),
  };
};
